import React, { type InputHTMLAttributes, useRef } from 'react';

import { ReactComponent as CheckIcon } from '@pkg/assets/icons/v2/check-input.svg';

import './ValidationInput.scss';

interface YatValidationInputProps extends InputHTMLAttributes<HTMLInputElement> {
    classes?: string[];
    isValid?: boolean;
    label?: string;
}

const YatValidationInput = ({ classes, isValid, label, ...props }: YatValidationInputProps) => {
    const classNames = ['yat-validation-form__input', ...(classes || [])];
    const urlInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

    function setFocusOnInput(e) {
        if (urlInputRef && urlInputRef.current) {
            urlInputRef.current.focus();
            e.preventDefault();
        }
    }

    return (
        <div className="yat-validation-form" onClick={setFocusOnInput}>
            <label className="yat-validation-form__label">{label}</label>
            <div className="yat-validation-form__container">
                <div className="yat-validation-form__prefix">https://</div>
                <input
                    className={classNames.join(' ')}
                    value={props.value}
                    placeholder={props.placeholder}
                    ref={urlInputRef}
                    {...props}
                />
                <div className={`yat-validation-form__check ${isValid ? 'icon-visible' : ''}`}>
                    <CheckIcon />
                </div>
            </div>
        </div>
    );
};

export default YatValidationInput;
